import { loginTypes, impersonateTypes } from '../auth/types';
import { getInvoicesTypes, getAssociatedInvoicesTypes, getAccountInvoicesTypes, getNotifTypes } from '../invoice/types';
import {
  getListTypes,
  getByIdTypes,
  deliveryVoucherTypes,
  purchaseOrderTypes,
  invoiceFileTypes,
  associatedInvoiceTypes
} from '../purchaseOrder/types';
import { toast } from 'react-toastify';

const mixedInvoiceTypes = [
  ...Object.keys(getInvoicesTypes).map(key => getInvoicesTypes[key]),
  ...Object.keys(getAssociatedInvoicesTypes).map(key => getAssociatedInvoicesTypes[key]),
  ...Object.keys(getAccountInvoicesTypes).map(key => getAccountInvoicesTypes[key]),
  ...Object.keys(getNotifTypes).map(key => getNotifTypes[key])
];
const mixedPurchaseOrderTypes = [
  ...Object.keys(getListTypes).map(key => getListTypes[key]),
  ...Object.keys(getByIdTypes).map(key => getByIdTypes[key]),
  deliveryVoucherTypes.GET_REQUEST,
  deliveryVoucherTypes.GET_SUCCESS,
  deliveryVoucherTypes.GET_FAILED
];

const readOnlyWhitelist = [
  ...Object.keys(loginTypes).map(key => loginTypes[key]),
  ...mixedInvoiceTypes,
  ...mixedPurchaseOrderTypes,
  '@@router/LOCATION_CHANGE',
  purchaseOrderTypes.SET_SELECTED_ORDER,
  associatedInvoiceTypes.GET_REQUEST,
  associatedInvoiceTypes.GET_FAILED,
  associatedInvoiceTypes.GET_SUCCESS,
  
  invoiceFileTypes.GET_REQUEST,
  invoiceFileTypes.GET_FAILED,
  invoiceFileTypes.GET_SUCCESS,

  impersonateTypes.ROLLBACK,
  impersonateTypes.ROLLBACK_SUCCESS
];
let time = Date.now();
let lastAction = '';

const readOnlyMiddleware = store => next => action => {
  const { getState } = store;
  let {
    auth: { isLoggedIn = null, user = null }
  } = getState();
  if (isLoggedIn) {
    // if the user is loggedIn, check if he is readOnly user.
    if (user.isReadonly) {
      if (readOnlyWhitelist.includes(action.type)) {
        return next(action);
      }
      if (time + 2000 < Date.now() && lastAction !== action.type) {
        lastAction = action.type;
        toast.warn('Usted no tiene permisos de escritura.');
        time = Date.now();
        console.log(new Error(`CALLED ACTION => ${action.type}`));
        return next({
          type: ''
        });
      }
    } else {
      return next(action);
    }
  } else {
    return next(action);
  }
};

export default readOnlyMiddleware;
